import React, { useEffect, useState } from "react";
import HomepageForm from "./component/homepageForm";
import { useSelector } from "react-redux";

import { Container } from "../styled/mypage";

import PageInfo from "../pageInfo";
import { useLocation } from "react-router";
import { toast } from "react-toastify";

export default function Hompage() {
  const setting = useSelector((state) => state?.user?.setting);
  const location = useLocation();
  const [portfolioImage, setPortfolioImage] = useState();

  useEffect(() => {
    const portfolio = location?.state?.images;
    setPortfolioImage(portfolio);

    if (portfolio) {
      toast.info("포트폴리오를 등록할 회사를 선택해주세요.", { toastId: "no-access" });
    }
  }, []);

  return (
    <Container className={setting?.mode}>
      <div className="content">
        <PageInfo label="홈페이지 목록" />
        <HomepageForm portfolio={portfolioImage} />
      </div>
    </Container>
  );
}
